module.exports = __webpack_public_path__ + "static/media/4.16_preview.b8996857.png";